<template>
  <li @click.stop.prevent="select" :class="{ 'is-selected': itemData.selected, 'error': itemData.error }">
    <span class="arrow_to_move" @click.stop.prevent>
      <i class="material-icons pointerClass" @click.stop.prevent="moveItemUp">keyboard_arrow_up</i>
      <i class="material-icons pointerClass" @click.stop.prevent="moveItemDown">keyboard_arrow_down</i>
    </span>
    <p class="d-inline-block" :class="{ bold: itemData.items && itemData.items.length > 0}">
      <span v-if="itemData.colorCode" class="color-preview" :style="{ 'background-color': itemData.colorCode }"></span>
      <small v-if="itemData.abbr">({{itemData.abbr[language]}})</small> {{itemData.name[language]}} <small v-if="itemData.itemId">[{{itemData.itemId}}]</small>
      <small>
        <span class="mx-2">-</span> {{ $lang.header.views }}: {{ formattedViews }}
        <span class="mx-2">-</span> {{ $lang.labels.printerCategories }}: {{ formattedPrintCategories }}
        <template v-if="formattedSettings"><span class="mx-2">-</span> {{ $lang.labels.settings }}: {{ formattedSettings }}</template>
        <template><span class="mx-2">-</span> {{ $lang.labels.VAT }}: {{ itemData.vatRate ? itemData.vatRate : 'none' }}</template>
        <template v-if="formattedSettings"><span class="mx-2">-</span> {{ $lang.labels.taxCategory }}: {{ itemData.taxCategory }}</template>
        <template v-if="itemData.minimumTotalPrice && isEdit"><span class="mx-2">-</span> {{ $lang.labels.defPrice }}: {{ itemData.minimumTotalPrice }}</template>
      </small>
    </p>
    <div class="item-actions d-inline-block">
      <i class="material-icons" @click.stop="addItemTrigger()">add</i>
      <i class="material-icons" @click.stop="addItemTrigger(true)">plus_one</i>
      <i class="material-icons" @click.stop="$emit('editItem', [[index], false])" @click="showCurrent()">edit</i>
      <i class="material-icons" @click.stop="$emit('deleted', [[index], false])">delete</i>
      <v-tooltip bottom>
      <v-icon class="copyItemClass" @click.stop="$emit('copyItem', [[index], false])" slot="activator">file_copy</v-icon>
        <span>{{ $lang.actions.copyItem }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-icon class="massAddClass" @click.stop="$emit('massAdd', [[index], false])" slot="activator">add_box</v-icon>
        <span>{{ $lang.actions.massAdd }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-icon class="massRemoveClass" @click.stop="$emit('massRemove', [[index], false])" slot="activator">indeterminate_check_box</v-icon>
        <span>{{ $lang.actions.massRemove }}</span>
      </v-tooltip>
      <i
        v-if="itemData.items && itemData.items.length > 0"
        class="material-icons"
        :class="{ 'primary--text': itemData.open }"
        @click.stop="$set(itemData, 'open', !itemData.open)">folder_open</i>
    </div>
    <ul @click.stop.prevent v-if="itemData.items" v-show="itemData.open">
      <item
        @addItem="selectFurther($event, 'addItem')"
        @editItem="selectFurther($event, 'editItem')"
        @click.stop.prevent
        v-for="(item, index) in itemData.items"
        :key="index"
        :index="index"
        :views="views"
        :isEdit="isEdit"
        :itemData="item"
        :items="itemData.items"
        @editItemPassing="editItemPassing"
        @deleted="selectFurther($event, 'deleted')"
        @copyItem="selectFurther($event, 'copyItem')"
        @massAdd="selectFurther($event, 'massAdd')"
        @massRemove="selectFurther($event, 'massRemove')"
        @selected="selectFurther($event, 'selected')"></item>
    </ul>
  </li>
</template>

<script>
  export default {
    props: ['itemData', 'index', 'items', 'views', 'isEdit'],
    data() {
      return {
        language: this.$cookie.get('lang') || 'en',
        selected: this.itemData.selected,
      };
    },
    computed: {
      formattedViews() {
        return this.views && this.views.length !== 0 && this.itemData.views.length !== 0 ? this.itemData.views
          .map(current => this.views.find(view => view.viewId === current) ? this.views.find(view => view.viewId === current).name[this.language] : '')
          .join(', ') : 'none';
      },
      formattedPrintCategories() {
        return this.itemData.printerCategories && this.itemData.printerCategories.length > 0 ?
          this.itemData.printerCategories.join(', ') :
          'none';
      },
      formattedSettings() {
        let settings = [];
        if (this.itemData.settings) {
          if (this.itemData.settings.labelPrint) {
            settings.push('Label print');
          }
          if (this.itemData.settings.askDetails) {
            settings.push('Ask details');
          }
        }
        if (this.itemData.vatPrint) {
          settings.push('VAT print');
        }
        if (this.itemData.noDiscount) {
          settings.push('No Discount');
        }
        if (this.itemData.galaxyCardBalance) {
          settings.push('Galaxy Card Balance');
        }
        return settings.join(', ');
      }
    },
    methods: {
      showCurrent() {
        this.$emit('editItemPassing', this.itemData);
      },
      editItemPassing(val) {
        this.$emit('editItemPassing', val);
      },
      arraymove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      },
      moveItemUp() {
        if (this.index === 0) {
          return;
        }
        let indexFrom = this.index;
        let indexTo = this.index - 1;
        if (!this.itemData.parentItem) {
          this.arraymove(this.items, indexFrom, indexTo)
        } else if (this.itemData.parentItem) {
          this.arraymove(this.items, indexFrom, indexTo);
        }
      },
      moveItemDown() {
        if (this.index === this.items.length - 1) {
          return;
        }
        let indexFrom = this.index;
        let indexTo = this.index + 1;
        if (!this.itemData.parentItem) {
          this.arraymove(this.items, indexFrom, indexTo)
        } else if (this.itemData.parentItem) {
          this.arraymove(this.items, indexFrom, indexTo)
        }
      },
      select() {
        const event = {
          select: !this.itemData.selected,
          path: [this.index],
        };
        this.$emit('selected', [event, false]);
      },
      addItemTrigger(plusOne = false) {
        this.selected = true;
        this.$emit('addItem', [[this.index], plusOne]);
      },
      selectFurther(event, label) {
        // this.selected = !this.selected;
        const send = event;
        if (label === 'selected') {
          send[0].path.push(this.index);
        } else {
          send[0].push(this.index);
        }
        this.$emit(label, send);
      },
    },
  };
</script>

<style scoped lang="scss">
  .color-preview {
    display: inline-block;
    margin-left: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid #bdbdbd;
  }

  ul {
    list-style: none;
    padding-left: 30px;
  }

  li {
    transition: all 125ms ease-in;
    padding: 5px 0;

    &.is-selected {
      font-size: 1.4rem;
      color: #FFB300;
    }

    &.error,
    &.error .item-actions i {
      color: #fff !important;
    }

    &:not(.is-selected) {
      font-size: 1rem;
      color: #333;
    }

    ul {
      p {
        position: relative;
        padding-left: 2rem;
        margin: 0;

        &:before {
          display: block;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 50%;
          width: 2px;
          background-color: rgba(0, 0, 0, 0.3);
        }

        &:after {
          display: block;
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          width: 1.5rem;
          height: 2px;
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

      &:not(:last-child) p:before {
        height: 100%;
      }

    }
  }

  .arrow_to_move {
    width: 10px;
    position: relative;
    display: inline-block;
    margin-right: 10px;

    i {
      font-size: 20px;
      display: inline;
      position: absolute;

      &:first-child {
        margin-top: -25px;
      }

      &:last-of-type {
        margin-top: -5px;
      }
    }
  }

  .item-actions {
    margin-left: 1rem;
    opacity: 0;
    transition: opacity 125ms ease-in;

    i {
      vertical-align: middle;
      cursor: pointer;
      padding: 5px;
      border-radius: 50%;
      color: #555;
      transition: color 125ms ease-in;

      &:hover {
        color: #111;
      }

      &:nth-child(2):hover {
        color: darkgoldenrod;
      }

      &:nth-child(4):hover {
        color: red;
      }
      &:nth-child(5):hover {
        color: blue;
      }
    }
  }

  li.is-selected > .item-actions,
  li:hover {
    color: #FFB300;

    & > .item-actions {
      opacity: 1;
    }
  }

  .bold {
    font-weight: 700;
  }

  .pointerClass {
    cursor: pointer;
  }

  .pointerClass:hover {
    font-weight: bold;
    color: red;
    cursor: pointer;
  }

  .copyItemClass:hover {
    color: blue !important;
  }

  .massAddClass:hover {
    color: green !important;
  }
  .massRemoveClass:hover {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// Item.vue?35255eb7